import '../../incubator/incubator.css';
import Plus from '../../../images/Plus.svg';
import Minus from '../../../images/Minus.svg';
import React, { useEffect, useState,useRef } from 'react';
// import pdf from '../../../images/PDF.svg';
import pdf from '../../../../images/PDF.svg'
import xls from '../../../../images/xls.svg';
import doc from '../../../../images/doc.svg';
import xlsx from '../../../../images/xls.svg';
import TrancheStepperComponent from '../TrancheStepperComponent';
import Stepper from 'bs-stepper';
import 'bs-stepper/dist/css/bs-stepper.min.css';
import {
  AddTranche,
  Documents,
  TrancheDetail,
} from '../../../../models/funddetails/TrancheDetails';
import {
  ADD_MORE_TRANCHE,
  ADD_TRANCHE_WITH_AMOUNT,
  ADD_TRANCHE_WITH_Re_AMOUNT,
  BASE_URL,
  GET_ALL_TRANCHES,
  GET_BANK_DETAILS,
  GET_BANK_DETAILS_REAPPLY_NODE,
  GET_INCUBATOR_DETAILS,
  GET_TRANCHE_REQUEST,
  NODE_URL,
  QUICK_EDIT,
  QUICK_Re_EDIT,
  File_base_url,
  TRANCHES_EDIT
} from '../../../../constants/api';
import { get, post } from '../../../../effects/api/api.common';
import TrancheInfoComponent from '../../../incubator/common/TrancheInfoComponent';
import TrancheWiseDetails from '../../../incubator/common/TrancheWiseDetails';
import { UploadTypeEnum } from '../../../../utils/Enums';
import { changeNumberFormat, createFile } from '../../../../utils/CommonMethods';
import { FileDownloadModel } from '../ApplicationGeneralDetails';
import AccountDetailsComponent from '../../../incubator/dashboard/AccountDetailsComponent';
import { AccountDetailsData } from '../../../../models/funddetails/AccountDetailsData';
import { getSessionStorageValue } from '../../../../effects/utils/session-storage';
import ReapplyTrancheDetailsComponent from '../../../incubator/dashboard/ReapplyTrancheDetailsComponent';
import ReapplyAccountDetailsComponent from '../../../incubator/dashboard/ReapplyAccountDetailsComponent';
import MergedTrancheDetailsComponent from './MergedTrancheDetailsComponent';
import MergedTrancheInfoComponent from './MergedTrancheInfoComponent';
import MergedTrancheWiseDetails from './MergedTrancheWiseDetails';
import MergedFirstTrancheWiseDetails from './MergedFirstTrancheWiseDetails';
import MergedFirstTrancheInfoComponent from './MergedFirstTrancheInfoComponent';
import ConfirmationDialogNote from '../../../common/controls/ConfirmationDialogNote';
import Allround from '../../../../images/Allround.svg';

interface IFundDetailsProps {
  application_id: number;
  total_grant_approved: any;
  trancheData: any;
  trancheDataFirst:any;
  trancheDataASC: any;
  accountDetailsData: AccountDetailsData;
  application_status:string;
  total_grant_disbursed:any;
  totalManagementAmount:any;
  leftSideData:any;
  // FundsData:any
  
}

function MergedFundDetailsComponent(props: any) {
  const {
    application_id,
    total_grant_approved,
    trancheData,
    trancheDataFirst,
    trancheDataASC,
    accountDetailsData1,
    accountDetailsData2,
    application_status,
    total_grant_disbursed,
    totalManagementAmount,
    total_no_tranches,
    leftSideData
  } = props;

  //  //console.log("***********",accountDetailsData1);

  const [isTrancheStepper, setStepper] = useState<boolean>(true);
  const [isEditing, setIsEditing] = useState(false);

  const [activeIndex, setActiveIndex] = useState('');
  const [ReapplyactiveIndex, setReapplyActiveIndex] = useState('3');
  const [ReapplytrancheData, setReapplyTrancheData] = useState<Array<TrancheDetail>>([
    new TrancheDetail(
      0,
      0,
      '',
      0,
      0,
      '',
      '',
      new Documents([], [], []),
      '',
      0,
      0,
      '',
      '',
      '',
      '',
      '',
      '', false, false, false,
      '',
      '',
      '',
      ''
    ),
  ])
  const changeActive = (id: string) => {
    setActiveIndex(id);
  };
  const changeActiveBack = () => {
    setActiveIndex('');
  };
  const [loggedInRole, setLoggedInRole] = useState('');
  const [ReaapplyInclistData, SetReaapplyInclistData] = useState('');
  const ReapplychangeActive = (id: string) => {
    setReapplyActiveIndex(id);
  };
  const [ReapplyAccountDataLength, setReapplyAccountDataLength] = useState("")
  const [ReapplyAccountData, setReapplyAccountData] = useState({
    bank_account_holder_name: "",
    bank_name: "",
    branch_name: "",
    account_type: "",
    account_number: "",
    bank_ifsc_code: "",
    bank_micr_code: "",
    branch_address: "",
    pan_card_location: "",
    cancelled_cheque_location: "",
    darpan_location: "",

  });
  const [total_grand_approved_amount, setGrantApproved] = useState("");
  const [total_Management_approved_amount, setManagementAmount] = useState("");
  const [tranchesno, setTranchesNo] = useState("");


  const [addMoreTrancheData1, setAddMoreTrancheData1] = useState<AddTranche>(
    new AddTranche(0, '', 0, 0)
  );
  const [addMoreTrancheData2, setAddMoreTrancheData2] = useState<AddTranche>(
    new AddTranche(0, '', 0, 0)
  );
  const [isAddTrancheRowVisible, setIsAddTrancheRowVisible] = useState(true);
  const [isAddTrancheRowVisible1, setIsAddTrancheRowVisible1] = useState(true);
  const [showEditSuccessModal, setShowSuccessModal] = useState(false);
  const [showEditFailureModal, setShowFailureModal] = useState(false);
  const [checked, setChecked] = useState(false);
  // const [count, setCount] = useState(0);
  const [employeeData, setEmployeeData] = useState<any>([])
  const [employeeData1, setEmployeeData1] = useState<any>([])
  const [showIncubatorFailureModal, setShowIncubatorFailureModal] = useState(false);
// const [sumOfSecond,setsumOfSecond]=useState(0)
// const [sumOfFirst,setsumOfFirst]=useState(0)

  const [failDialogData, setFailDialogData] = useState({
    "header":'',
    "text":'',    
    "note":''
  });
  const dismissModal = () => {
    setShowSuccessModal(false);
    setShowFailureModal(false);
          // history.push('/merged_Incubator_Details_list')

    window.location.reload()
  };
  const dismissModal1 = () => {
    // setShowSuccessModal(false);
    setShowFailureModal(false);
          // history.push('/merged_Incubator_Details_list')

    // window.location.reload()
  };
 
  const [final2,setFinal2]=useState<any>([])
  const [final1,setFinal1]=useState<any>([])


 
   
  useEffect(()=>{
   
    {trancheData.map((item:any,index:any)=>{
      if(index==0){
        item.map((newItem:any,index:any)=>{
         setFinal2(newItem)
        })
      }
    })}
   
    {trancheDataFirst.map((item:any,index:any)=>{
      if(index==0){
        item.map((newItem:any,index:any)=>{
         setFinal1(newItem)
        })
      }
    })}
     //console.log(accountDetailsData2,accountDetailsData1,"accountDetailsData12333")
    // ReapplygetAccountDetails()
    setEmployeeData(trancheData[0])
    setEmployeeData1(trancheDataFirst[0])
     //console.log(employeeData,"emp")
    // let sumSecond = employeeData.reduce(function(prev :any, current:any) {
    //   return prev + +current.approved_amount
    // }, 0); 
    // setsumOfSecond(sumSecond)
    // let sumFirst = employeeData1.reduce(function(prev :any, current:any) {
    //   return prev + +current.approved_amount
    // }, 0); 
    // setsumOfFirst(sumFirst)
  },[total_grand_approved_amount,trancheData,trancheDataFirst])
  useEffect(() => {
   
    setStepper(true);
    const user: any = getSessionStorageValue("user");
    const userInfo = JSON.parse(user)
    setLoggedInRole(userInfo.roles);
    // getAccountDetails();
     //console.log(total_grant_approved,"total_grant_approvedtotal_grant_approved")
    setGrantApproved(total_grant_approved == null ? "0" : total_grant_approved);
     //console.log(totalManagementAmount,"totalManagementAmounttotalManagementAmount")
    setManagementAmount((totalManagementAmount==null)?"0": totalManagementAmount)
    setTranchesNo(total_no_tranches==null?"0": total_no_tranches)
      //console.log(tranchesno,"application_idapplication_id")
  
  }, [total_grant_approved,total_no_tranches,accountDetailsData1,accountDetailsData2]);
  const addMoreTranche2 = () => {
    let addTranche = JSON.parse(JSON.stringify(addMoreTrancheData2));
     //console.log(final2.application_id,"106")
    addTranche['application_id'] = ((final2.application_id==""||final2.application_id==0||final2.application_id==undefined)?application_id:final2.application_id);
     //console.log(addTranche)
    setAddMoreTrancheData2(addTranche);
    setIsAddTrancheRowVisible(true);

    let sum = employeeData.reduce(function(prev :any, current:any) {
      return prev + +current.approved_amount
    }, 0); 
 
 if(typeof addMoreTrancheData2.amount_approved === "string"){
  addMoreTrancheData2.amount_approved = Number(addMoreTrancheData2.amount_approved)
 }
 
  if(addMoreTrancheData2.amount_approved == 0){
    setShowFailureModal(true);
  }else if((sum+addMoreTrancheData2.amount_approved)>final2.total_grant_amount+final2.total_management_amount){
    setFailDialogData({
      "header":"Oops",
      "text":"Can’t create new tranche, approved amount is equal to total grant approved and total management fees",
      "note":"Note : If you still want to create a new tranche please check Total funds Approved & Total Funds Disbursed (If Total Funds Disbursed is lesser than Total funds Approved in existing tranches please decrease Total Funds Approved)"
    })
    setShowIncubatorFailureModal(true);
  }else{
    const user: any = getSessionStorageValue("user");
    const userInfo = JSON.parse(user)    
    const userId = userInfo.id
    let addMoreTrancheDetails = {
      application_id: ((final2.application_id==""||final2.application_id==0||final2.application_id==undefined)?application_id:final2.application_id),
      approved_amount: addMoreTrancheData2.amount_approved,
      logged_user_id:userId
    };
    //console.log(final2.id,"final2final2")
  //  return
    post(`${ADD_TRANCHE_WITH_Re_AMOUNT}`, addMoreTrancheDetails).then(
      (response: any) => {
        if (!response || !response.data) return;
        if (response.data.result == 'success') {
          setShowSuccessModal(true);
          //  window.location.reload()

        } 
        else {
          // setShowFailureModal(true);
        }
        // //console.log(addMoreTrancheData, 'setaddMoreTrancheData');
        // getAllTranches();
      }
    );
  }
  };
 //2nd Edit button clicked
  const addMoreTranche2Edit = (tranch_id:any)=>{
//  //console.log(trancheData[0])

 trancheData[0].forEach((element :any,index :any) => {   
      if(element.tranch_id == tranch_id){
         //console.log("into if") 
        element.editchecked = "No"          
      }
      else{
        element.editchecked = "Yes"         
      }
     
  });
    // setEmployeeData([...trancheData[0],trancheData[0]])
    setEmployeeData([...trancheData[0],trancheData[0]])
    const newArray =  employeeData.splice(0,employeeData.length)
    setEmployeeData(newArray)
    //console.log(employeeData,"emp")

  }
//2nd Handle change
  const handleChangeEdit2 = (e:any,
    tranch_id: any
  ) => {
    const { name, value } = e.target
    var editData:any = []
     editData = employeeData.map((item:any) =>
      item.tranch_id === tranch_id && name ? { ...item, [name]: value } : item
    )
    setEmployeeData(editData)
   
  };
  
  const addMoreTranche2Save =(item:any,i:any,fund:any)=> {
    setChecked(false)   
    let totalfunds = final2.total_grant_amount + final2.total_management_amount   
    // let sum = employeeData.reduce(function(prev :any, current:any) {
    //   return prev + +current.fund_released
    // }, 0);   
    let sumApprove = employeeData.reduce(function(prev :any, current:any) {
      return prev + +current.approved_amount
    }, 0);    
    approved.current = parseInt(item.approved_amount)
    funds.current = parseInt(item.fund_released)
   //console.log(sumApprove,"^^^^^^")
   console.log(item.tranches_status_label,"labelssss")

   if(item.tranches_status_label !== 'Disbursement in Process'){
    setFailDialogData({
      "header":"Oops",
      "text":"Tranche Status should be in Disbursement in Process",
      "note":""
    })
    setShowIncubatorFailureModal(true);  
  }else if(approved.current == 0){
    setShowFailureModal(true);
  }else if(sumApprove > totalfunds){
      setFailDialogData({
        "header":"Oops",
        "text":"Entered Amount should be less than or equal to Total Grant Approved & Total Management Fees",
        "note":""

      })
      setShowIncubatorFailureModal(true);   
      return; 
    }else if(approved.current<funds.current){      
      setFailDialogData({
        "header":"Oops",
        "text":"Amount Disbursed should be less than or equal to Approved Amount",
        "note":""

      })
      setShowIncubatorFailureModal(true);  
      return;    
    // } 
    // else if(sum > totalfunds){
    // setFailDialogData({
    //   "header":"Oops",
    //   "text":"Entered Amount should be lesser than Total Grant Approved & Total Management Fees"
    // })
    // setShowIncubatorFailureModal(true);   
    // return; 
  }else{
   
    const payload ={
      "application_id":item.application_id,
        "tranche_id":item.tranch_id,
       "amount_approved":item.approved_amount,
        "amount_released":item.fund_released,
        "application_index":item.application_index
    }
     //console.log(payload,"addMoreTrancheData2")
    
    post(TRANCHES_EDIT, payload).then(
      (response: any) => {
        if (!response || !response.data) return;
         //console.log(response.data,"resulttttt")
        if (response.data.result == 'success') {
          setShowSuccessModal(true);
        

        } 
        else {
          // setShowFailureModal(true);
        }
       
      }
    );
    }
  }
//model 
// const closeModel = ()=> {
// setShowIncubatorFailureModal(false)
// window.location.reload()
// }
  //1st Edit button clicked
  const addMoreTranche1Edit = (tranch_id:any)=>{
  
    //  //console.log(trancheData[0])
     trancheDataFirst[0].forEach((element :any,index :any) => {   
          if(element.tranch_id == tranch_id){
             //console.log("into if") 
            element.editchecked = "No"  
          }
          else{
            element.editchecked = "Yes"          
          }
      });
    
    
        setEmployeeData1([...trancheDataFirst[0],trancheDataFirst[0]])
        // const newArray =  employeeData.pop()
        // setEmployeeData(employeeData)
        //console.log(employeeData1,"emp1")
       const newArray =  employeeData1.splice(0,employeeData1.length)
       setEmployeeData1(newArray)
      }
      //1st Handle change
  const handleChangeEdit1 = (e:any,
    tranch_id: any
  ) => {
    const { name, value } = e.target
    var editData1:any = []
     editData1 = employeeData1.map((item:any) =>
      item.tranch_id === tranch_id && name ? { ...item, [name]: value } : item
    )

    setEmployeeData1(editData1)
    //  //console.log(name,evt,i,"poppp")
    // trancheData[0]({ ...trancheData, [name]: evt });
    
    
  };
  //1st sva 
  const addMoreTranche1Save =(item:any,i:any)=> {
    setChecked(false)
    let totalfunds1 = final1.total_grant_amount + final1.total_management_amount   

    // let sum1 = employeeData1.reduce(function(prev :any, current:any) {
    //   return prev + +current.fund_released
    // }, 0);
    let sumApprove1 = employeeData1.reduce(function(prev :any, current:any) {
      return prev + +current.approved_amount
    }, 0); 
     //console.log(sumApprove1,"sumApprove1")
    approved1.current = parseInt(item.approved_amount)
    funds1.current = parseInt(item.fund_released)
    if(item.tranches_status_label !== 'Disbursement in Process'){
      setFailDialogData({
        "header":"Oops",
        "text":"Tranche Status should be in Disbursement in Process",
        "note":""
      })
      setShowIncubatorFailureModal(true);  
    }else if(approved1.current == 0){
      setShowFailureModal(true);
    }else if(sumApprove1 > totalfunds1){
      setFailDialogData({
        "header":"Oops",
        "text":"Entered Amount should be less than or equal to Total Grant Approved & Total Management Fees",
      "note":""

      })
      setShowIncubatorFailureModal(true); 
    }else if(approved1.current < funds1.current){      
      setFailDialogData({
        "header":"Oops",
        "text":"Amount Disbursed should be less than or equal to Approved Amount",
      "note":""

      })
      setShowIncubatorFailureModal(true);
    // } 
    // else if(sum1 > totalfunds1){
    //   setFailDialogData({
    //     "header":"Oops",
    //     "text":"Entered Amount should be lesser than Total Grant Approved & Total Management Fees"
    //   })
    //   setShowIncubatorFailureModal(true); 
    } else{
    const payload ={
      "application_id":item.application_id,
        "tranche_id":item.tranch_id,
       "amount_approved":item.approved_amount,
        "amount_released":item.fund_released,
        "application_index":item.application_index
    }
    
    post(TRANCHES_EDIT, payload).then(
      (response: any) => {
        if (!response || !response.data) return;
         //console.log(response.data,"resulttttt")
        if (response.data.result == 'success') {
          setShowSuccessModal(true);
        

        } 
        else {
          // setShowFailureModal(true);
        }
       
      }
    );
    }
  }
  const addMoreTranche1 = () => {
     //console.log(application_id,"application_id")
    let addTranche = JSON.parse(JSON.stringify(addMoreTrancheData1));
    addTranche['application_id'] = ((final1.application_id==""||final1.application_id==0||final1.application_id==undefined)?application_id:final1.application_id);
    setAddMoreTrancheData1(addTranche);
    setIsAddTrancheRowVisible1(true);
    
    // let sum = employeeData1.reduce(function(prev :any, current:any) {
    //   return prev + +current.fund_released
    // }, 0); 
    let sum1 = employeeData1.reduce(function(prev :any, current:any) {
       //console.log(current,"current@@@")
      return prev + +current.approved_amount
    }, 0); 
    if(typeof addMoreTrancheData1.amount_approved === "string"){
      addMoreTrancheData1.amount_approved = Number(addMoreTrancheData1.amount_approved)
     }
    if(addMoreTrancheData1.amount_approved == 0){
      setShowFailureModal(true);
    }else if((sum1+addMoreTrancheData1.amount_approved)>(final1.total_grant_amount+final1.total_management_amount)){
      setFailDialogData({
        "header":"Oops",
        "text":"Can’t create new tranche, approved amount is equal to total grant approved and total management fees",
        "note":"Note : If you still want to create a new tranche please check Total Funds Approved & Total Funds Disbursed (If Total Funds Disbursed is lesser than Total Funds Approved in existing tranches please decrease Total Funds Approved)"
      })
      setShowIncubatorFailureModal(true);
    }else{
    let addMoreTrancheDetails = {
      application_id: ((final1.application_id==""||final1.application_id==0||final1.application_id==undefined)?application_id:final1.application_id),
      approved_amount: addMoreTrancheData1.amount_approved,
    };

    post(`${ADD_TRANCHE_WITH_AMOUNT}`, addMoreTrancheDetails).then(
      (response: any) => {
        if (!response || !response.data) return;
         //console.log(response.data.result,"resulttttt")
        if (response.data.result == 'success') {
    setIsAddTrancheRowVisible1(true);

          setShowSuccessModal(true);
          
        } else {
          // setShowFailureModal(true);
        }
        //getAllTranches();
      }
    );
    }
  };
  const cancel = () => { 
window.location.reload()

  };

  const handleChange2 = (
    evt: React.ChangeEvent<
      HTMLSelectElement | HTMLInputElement | HTMLTextAreaElement
    >
  ) => {
    const name = evt.target.name;
    const value = evt.target.value;

    let trancheDetails = JSON.parse(JSON.stringify(trancheData));
    if (name == "amount_approved") {

      const numStr = String(evt.target.value);
      var count = 0;
      if (numStr.includes('.')) {
        count = numStr.split('.')[1].length;
      };
      if (count > 2) {
        trancheDetails[name] = Number(evt.target.value).toFixed(2);
      }
      else { trancheDetails[name] = evt.target.value; }

    }
    else {
      trancheDetails[name] = evt.target.value;
    }

    setAddMoreTrancheData2(trancheDetails);
  };
  const handleChange1 = (
    evt: React.ChangeEvent<
      HTMLSelectElement | HTMLInputElement | HTMLTextAreaElement
    >
  ) => {
    const name = evt.target.name;
    const value = evt.target.value;

    let trancheDetails = JSON.parse(JSON.stringify(trancheDataFirst));
    if (name == "amount_approved") {

      const numStr = String(evt.target.value);
      var count = 0;
      if (numStr.includes('.')) {
        count = numStr.split('.')[1].length;
      };
      if (count > 2) {
        trancheDetails[name] = Number(evt.target.value).toFixed(2);
      }
      else { trancheDetails[name] = evt.target.value; }

    }
    else {
      trancheDetails[name] = evt.target.value;
    }

    setAddMoreTrancheData1(trancheDetails);
  };
 
  const handleChangeTotalGrantApproved2 = (evt: React.ChangeEvent<
    HTMLSelectElement | HTMLInputElement | HTMLTextAreaElement
  >) => {
    const name = evt.target.name;
    const value = evt.target.value;

    let quickEdit = JSON.parse(JSON.stringify(quickEditPopupData));

    const numStr = String(evt.target.value);
    var count = 0;
    if (numStr.includes('.')) {
      count = numStr.split('.')[1].length;
    };
    if (count > 2) {
      quickEdit[name] = Number(evt.target.value).toFixed(2);
    }
    else { quickEdit[name] = evt.target.value; }

    //quickEdit["total_approved_amt"] = value;
    setQuickEditPopupData(quickEdit);
  }

  const handleChangeTotalGrantApproved1 = (evt: React.ChangeEvent<
    HTMLSelectElement | HTMLInputElement | HTMLTextAreaElement
  >) => {
    const name = evt.target.name;
    const value = evt.target.value;

    let quickEdit = JSON.parse(JSON.stringify(quickEditPopupData));

    const numStr = String(evt.target.value);
    var count = 0;
    if (numStr.includes('.')) {
      count = numStr.split('.')[1].length;
    };
    if (count > 2) {
      quickEdit[name] = Number(evt.target.value).toFixed(2);
    }
    else { quickEdit[name] = evt.target.value; }

    //quickEdit["total_approved_amt"] = value;
    setQuickEditPopupData(quickEdit);
  }
  const formatDate = (date: string) => {
    var month = new Array();
    month[0] = 'Jan';
    month[1] = 'Feb';
    month[2] = 'Mar';
    month[3] = 'April';
    month[4] = 'May';
    month[5] = 'Jun';
    month[6] = 'Jul';
    month[7] = 'Aug';
    month[8] = 'Sep';
    month[9] = 'Oct';
    month[10] = 'Nov';
    month[11] = 'Dec';

    var d = new Date(date),
      monthn = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

    if (monthn.length < 2) monthn = '0' + monthn;
    if (day.length < 2) day = '0' + day;

    return [day, month[d.getMonth()], year].join(' ');
  };
  // const [total,set_total]=useState(0);
  const approved = useRef(0)
  const funds = useRef(0)
  const approved1 = useRef(0)
  const funds1 = useRef(0)

  const [quickEditPopupData, setQuickEditPopupData] = useState({ application_id: "", total_approved_amt: "", application_status: "",total_disbursed_amt:"" });
  const updateTotalGrantApproved2 = () => {
    if(quickEditPopupData.total_disbursed_amt > quickEditPopupData.total_approved_amt){
      setFailDialogData({
        "header":"Oops",
        "text":"Entered amount is lesser than total Funds Disbursed to Incubator",
        "note":""
      })
      
      setShowIncubatorFailureModal(true);  
    }else{
    var payload = {
      application_id: ((final2.application_id==""||final2.application_id==0||final2.application_id==undefined)?application_id:final2.application_id),
      total_approved_amt: quickEditPopupData.total_approved_amt,
      application_status: "7"
    }

    post(QUICK_Re_EDIT, payload).then((response: any) => {
      if (!response || !response.data) return;
       //console.log(response.data)


      if (response.data.result == "success") {
         //console.log(response.data)
        window.location.reload()
        setGrantApproved(quickEditPopupData.total_approved_amt);
        setManagementAmount(response.data.data.total_management_amount.toString())
        // setManagementAmount(amountMangement)
       
        
      }
      else {

      }
       //console.log(response.data)
    });
  }
  }
  const updateTotalGrantApproved1 = () => {
    if(quickEditPopupData.total_disbursed_amt > quickEditPopupData.total_approved_amt){
      setFailDialogData({
        "header":"Oops",
        "text":"Entered amount is lesser than total Funds Disbursed to Incubator",
        "note":""
      })
      
      setShowIncubatorFailureModal(true);  
    }else{
    var payload = {
      application_id: ((final1.application_id==""||final1.application_id==0||final1.application_id==undefined)?application_id:final1.application_id),
      total_approved_amt: quickEditPopupData.total_approved_amt,
      application_status: "7"
    }

    post(QUICK_EDIT, payload).then((response: any) => {
      if (!response || !response.data) return;
       //console.log(response.data)


      if (response.data.result == "success") {
         //console.log(response.data)
        window.location.reload()
        setGrantApproved(quickEditPopupData.total_approved_amt);
        setManagementAmount(response.data.data.total_management_amount.toString())
        // setManagementAmount(amountMangement)

       
        
      }
      else {

      }
       //console.log(response.data)
    });
  }
  }
  const setQuickEdit = (value: string,value1:string) => {
    let quickEdit = JSON.parse(JSON.stringify(quickEditPopupData));
    // quickEdit["total_approved_amt"] = Number(value).toFixed();
    quickEdit["total_approved_amt"] = Number(value);
    quickEdit["total_disbursed_amt"] = Number(value1);

    
    setQuickEditPopupData(quickEdit);

  }



  const getFileDetails = (file: any, key: string) => {
    let file_name = '';
    let file_ext = '';
    file_name =
      file != undefined && file.length > 1
        ? file.substr(file.lastIndexOf('/') + 1, file.length)
        : '';
    file_ext = file != undefined && file.length > 1
      ? file.substr(
        file.lastIndexOf('.') + 1,
        file.length
      ) : "";
    if (key == 'ext') return file_ext;
    if (key == 'name') return file_name;
    if (key == 'file') return file.toString();
  };

  const downloadDocument = (file: any, file_name: any) => {
     //console.log(file,"download file")
    let file_name1 =
      file_name != undefined && file_name.length > 1
        ? file_name.substr(file_name.lastIndexOf('/') + 1, file_name.length)
        : '';
         //console.log(`${File_base_url}`+file,"file")
        
    fetch(`${File_base_url}`+file).then((response) => {
      response.blob().then((blob) => {
        let url = window.URL.createObjectURL(blob);
        let a = document.createElement('a');
        a.href = url;
        a.download = file_name1;
        a.click();
      });
      //window.location.href = response.url;
    });
  };
  const downloadDocument1 = (file: any, file_name: any) => {
     //console.log(file,"download file")
    let file_name1 =
      file_name != undefined && file_name.length > 1
        ? file_name.substr(file_name.lastIndexOf('/') + 1, file_name.length)
        : '';
        
    fetch(file).then((response) => {
      response.blob().then((blob) => {
        let url = window.URL.createObjectURL(blob);
        let a = document.createElement('a');
        a.href = url;
        a.download = file_name1;
        a.click();
      });
      //window.location.href = response.url;
    });
  };
  const ReapplygetAccountDetails = () => {
    const user: any = getSessionStorageValue("user");
    const userInfo = JSON.parse(user)
    const userId = userInfo.id
    post(`${GET_BANK_DETAILS_REAPPLY_NODE}`, { "logged_user_id": leftSideData.user_id }).then((response: any) => {
      if (!response || !response.data) return;
       //console.log(response.data,"ReapplyAccountData");
       //console.log(Object.values(response.data))
      setReapplyAccountDataLength(response.data.data);
      if (response.data.data.length > 0) {
        setReapplyAccountData(response.data.data[0]);
         //console.log(ReapplyAccountData,"ReapplyAccountData");
      }
     
    });

  };
  return (  
      <div className="container">
      <div className="row">   
      {/* { //console.log(trancheData.length,"trancheData")}
      { //console.log(trancheDataFirst.length,"trancheDataFirst")} */}
<div className="row col-md-12 pt-2 pb-2 m-3" style={{ backgroundColor: "#f8f7f7" }}>
                  
                  <p className="dashboard pt-2 pl-2">Total Fund Details</p>
                
              </div>  
              <br></br>
        <div className="col-md-3 left-align" style={{maxWidth:'20%'}}>
          <span className="fund-amount-cur">
            &#8377;
            <label className="fund-amount-label-value">
              {' '}
              {total_grand_approved_amount != null && total_grand_approved_amount != "0"
                ? changeNumberFormat(Number(total_grand_approved_amount), 2, 1)
                : 0}
            </label>
            {/* Cr */}
          </span>
          <br />
          <span className="fund-amount-label">Total Grant Approved</span>
          <br />
          {/* { console.log(application_status,loggedInRole,"application_status")} */}
          {/* {(application_status == "selected" && loggedInRole != "eac")
            ?
            <a className="incubator-details-link"
              data-target="#editTotalGrantApproved"
              data-toggle="modal"
              onClick={() => setQuickEdit(total_grand_approved_amount.toString())}
            >Edit</a>

            :
            ""} */}

        </div>
        <div className="vl vl-mr"></div>
        <div className="col-md-3 left-align" style={{maxWidth:'20%'}}>
          <span className="fund-amount-cur">
            &#8377;
            <label className="fund-amount-label-value">
              {/* {console.log(total_Management_approved_amount,"336")} */}
              {' '}
              {total_Management_approved_amount !== null && total_Management_approved_amount !=="0"
                ? changeNumberFormat(Number(total_Management_approved_amount), 2, 1)
                : 0}
            </label>
            {/* Cr */}
          </span>
          <br />
          <span className="fund-amount-label">Total Management <br/>Fees</span>
          <br />
        </div>
        <div className="vl vl-mr"></div>
        <div className="col-md-3 left-align" style={{maxWidth:'20%'}}>
          <span className="fund-amount-cur">
            <label className="fund-amount-label-value">
              
              {tranchesno}
            </label>
          </span>
          <br />

          <span className="fund-amount-label">Total No. of Tranches</span>
          <br />
          {/* {loggedInRole != "eac" && <a
            className="incubator-details-link"
            data-target="#addMoreTranchePopUp"
            data-toggle="modal"
          >
            Add More Tranche
          </a>} */}
        </div>

        <div className="vl vl-mr"></div>
        <div className="col-md-3 " style={{maxWidth:'20%'}}>
          <span className="fund-amount-cur">
            &#8377;
            <label className="fund-amount-label-value">
              {' '}
              {total_grant_disbursed != null ? changeNumberFormat(Number(total_grant_disbursed.toString()), 2, 1) : 0}{' '}
            </label>

          </span>
          <br />
          <span className="fund-amount-label">
            Total Funds Disbursed to Incubator
          </span>
          <br />
          {/* <a
            className="incubator-details-link"
            data-target="#viewBankDetails"
            data-toggle="modal"
          >
            View Bank Details
          </a> */}
        </div>
      </div>
<br></br>
{/* 2nd Tranche details ************************************/}
      
      {leftSideData.application_index == 'R1' &&leftSideData.status_id=='7'?
        <div className="row">   
        <div className="row col-md-12 pt-2 pb-2 m-3" style={{ backgroundColor: "#f8f7f7" }}>
                  
                    <p className="dashboard pt-2 pl-2">2<sup>nd</sup> Application Fund Details</p>
                  
                </div>  
                <br></br>
                <div className="col-md-3 left-align" style={{maxWidth:'20%'}}>
            <span className="fund-amount-cur">
              &#8377;
              {/* { console.log(final2.total_grant_amount,"222222222222222222")} */}
              <label className="fund-amount-label-value">
                {' '}
                {final2.total_grant_amount != null && final2.total_grant_amount != "0"
                  ? changeNumberFormat(Number(final2.total_grant_amount), 2, 1)
                  : 0}
              </label>
              {/* Cr */}
            </span>
            <br />
            <span className="fund-amount-label">Total Grant Approved</span>
            <br />
            {(application_status == "Selected" && loggedInRole != "eac")
              ?
              <a className="incubator-details-link"
                data-target="#editTotalGrantApproved2"
                data-toggle="modal"
                onClick={() => setQuickEdit(final2.total_grant_amount.toString(),final2.total_disbursed_amt.toString())}
              >Edit</a>
  
              :
              ""}
  
          </div>
          <div className="vl vl-mr"></div>
          <div className="col-md-3 left-align" style={{maxWidth:'20%'}}>
            <span className="fund-amount-cur">
              &#8377;
              <label className="fund-amount-label-value">
                {/* { //console.log(total_Management_approved_amount,"336")} */}
                {' '}
                
                {final2.total_management_amount != null && final2.total_management_amount !=0
                  ? changeNumberFormat(Number(final2.total_management_amount), 2, 1)
                  : 0}
              </label>
              {/* Cr */}
            </span>
            <br />
            <span className="fund-amount-label">Total Management <br/>Fees</span>
            <br />
          </div>
          <div className="vl vl-mr"></div>
          <div className="col-md-3 left-align" style={{maxWidth:'20%'}}>
            <span className="fund-amount-cur">
              <label className="fund-amount-label-value">              
                {final2.total_no_of_tranches==null?0:final2.total_no_of_tranches}
              </label>
            </span>
            <br />
  
            <span className="fund-amount-label">Total No. of Tranches</span>
            <br />
            {loggedInRole != "eac" && <a
              className="incubator-details-link"
              data-target="#addMoreTranchePopUp"
              data-toggle="modal"
            >
              Add More Tranche
            </a>}
          </div>
  
          <div className="vl vl-mr"></div>
          <div className="col-md-3 " style={{maxWidth:'20%'}}>
            <span className="fund-amount-cur">
              &#8377;
              <label className="fund-amount-label-value">
                {' '}
                {final2.total_disbursed_amt != null ? changeNumberFormat(Number(final2.total_disbursed_amt.toString()), 2, 1) : 0}{' '}
              </label>
  
            </span>
            <br />
            <span className="fund-amount-label">
              Total Funds Disbursed to Incubator
            </span>
            <br />
            <a
              className="incubator-details-link"
              data-target="#viewBankDetails2"
              data-toggle="modal"
            >
              View Bank Details
            </a>
          </div>
          </div>:null
      }

{leftSideData.application_index == 'R1' &&leftSideData.status_id=='7'?
    
      (final2.length !==0?((final2.tranch_id !== null)?
      <span>       
      <div className="row col-md-12">
        <div className="col-md-12">
          <MergedTrancheInfoComponent trancheDetailsModel={trancheData} />
        </div>
      </div> 
      <div className="row">
        <div className="col-md-12 left-align">
          <span className="eac-heading-title"> No. of Tranches</span>
        </div>
      </div>
      <div className='row'>
        
      </div>
      <div className="application-incubator-hr">
        <hr />
      </div>
     
      <div className="row">
        
        <div className="col-md-12">
          <MergedTrancheWiseDetails trancheDetailsModel={trancheData} total_managment={final2.total_management_amount} total_grant_approved={final2.total_grant_amount} />
          {/* sumOfSecond={sumOfSecond} */}
        </div>
      </div> 
      </span>
      :null):null)
      
      :null}
     
{/* </div> */}



      
{/* 1st Tranche details ************************************/}
{/* {console.log(final1,"lengthhhhhhhh")} */}
{/* {trancheDataFirst.length &&  */}
 <div className='row'>
      <div className="row col-md-12 pt-2 pb-2 m-3" style={{ backgroundColor: "#f8f7f7" }}>                
                  <p className="dashboard pt-2 pl-2">1<sup>st</sup> Application Fund Details</p>              
        </div>  
              <br></br>
              <div className="col-md-3 left-align" style={{maxWidth:'20%'}}>
          <span className="fund-amount-cur">
            &#8377;
            {/* {console.log(final1.total_grant_amount,"222222222222222222")} */}
            <label className="fund-amount-label-value">
              {' '}
              {final1.total_grant_amount != null && final1.total_grant_amount != "0"
                ? changeNumberFormat(Number(final1.total_grant_amount), 2, 1)
                : 0}
            </label>
            {/* Cr */}
          </span>
          <br />
          <span className="fund-amount-label">Total Grant Approved</span>
          <br />
          {(application_status == "Selected" && loggedInRole != "eac")
            ?
            <a className="incubator-details-link"
              data-target="#editTotalGrantApproved1"
              data-toggle="modal"
              // .toString()
              onClick={() => setQuickEdit(final1.total_grant_amount,final1.total_disbursed_amt)}
            >Edit</a>

            :
            ""}

        </div>
        <div className="vl vl-mr"></div>
        <div className="col-md-3 left-align" style={{maxWidth:'20%'}}>
          <span className="fund-amount-cur">
            &#8377;
            <label className="fund-amount-label-value">
              {/* { //console.log(total_Management_approved_amount,"336")} */}
              {' '}
              {(final1.total_management_amount != null && final1.total_management_amount !="0")
                ? changeNumberFormat(Number(final1.total_management_amount), 2, 1)
                : 0}
            </label>
            {/* Cr */}
          </span>
          <br />
          <span className="fund-amount-label">Total Management <br/>Fees</span>
          <br />
        </div>
        <div className="vl vl-mr"></div>
        <div className="col-md-3 left-align" style={{maxWidth:'20%'}}>
          <span className="fund-amount-cur">
            <label className="fund-amount-label-value">              
              {final1.total_no_of_tranches==null?0:final1.total_no_of_tranches}
            </label>
          </span>
          <br />

          <span className="fund-amount-label">Total No. of Tranches</span>
          <br />
          {loggedInRole != "eac" && <a
            className="incubator-details-link"
            data-target="#addMoreTranchePopUp1"
            data-toggle="modal"
          >
            Add More Tranche
          </a>}
        </div>

        <div className="vl vl-mr"></div>
        <div className="col-md-3 " style={{maxWidth:'20%'}}>
          <span className="fund-amount-cur">
            &#8377;
            <label className="fund-amount-label-value">
              {' '}
              {final1.total_disbursed_amt != null ? changeNumberFormat(Number(final1.total_disbursed_amt.toString()), 2, 1) : 0}{' '}
            </label>

          </span>
          <br />
          <span className="fund-amount-label">
            Total Funds Disbursed to Incubator
          </span>
          <br />
          <a
            className="incubator-details-link"
            data-target="#viewBankDetails1"
            data-toggle="modal"
          >
            View Bank Details
          </a>
        </div>
</div>
{/* {console.log(final1.tranch_id,"tranche_id")} */}
{final1.length !==0?
((final1.tranch_id !== null)?
  <span>   
   
        {/* <div className='row'> */}
      <div className="row">
        <div className="col-md-12">
          <MergedFirstTrancheInfoComponent trancheDetailsModel={trancheDataFirst} />
        </div>
      </div> 
      <div className="row">
        <div className="col-md-12 left-align">
          <span className="eac-heading-title">No. of Tranches</span>
        </div>
      </div>
      <div className="application-incubator-hr">
        <hr />
      </div>
      {/* <div className="application-incubator-hr">
        <hr />
      </div> */}
      <div className="row">
        {/* {console.log(trancheDataFirst,"trancheDataFirsttrancheDataFirst")} */}
        <div className="col-md-12">
          <MergedFirstTrancheWiseDetails trancheDetailsModel={trancheDataFirst} total_managment={final1.total_management_amount} total_grant_approved={final1.total_grant_amount} />
          {/* sumOfFirst={sumOfFirst} */}
        </div>
      </div>
      {/* </div> */}
      </span>:null):null} 
      
    

      {/* 2nd //Add more tranche */}

      <div
        className="modal fade"
        id="addMoreTranchePopUp"
        role="dialog"
        aria-labelledby="exampleModalCenterTitle"
        aria-hidden="true"
        data-backdrop="static"
        data-keyboard="false"
      >
        <div
          className="modal-dialog modal-dialog-centered modal-lg"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header modal-header-border-none ml-18px">
              <h5 className="modal-title pl-2" id="exampleModalLongTitle">
                Add More Tranche<span></span>
              </h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"                
                aria-label="Close"
              >
                <span aria-hidden="true" onClick={cancel}>&times;</span>
              </button>
            </div>
            <div className="modal-body mt-15-px">
              <div className="container">
                <div className="row">
                  <div className="col-md-3 left-align">
                    <span className="fund-amount-cur">
                      &#8377;
                      <span className="fund-amount-label-value">
                        {' '}
                        {/* {total_grand_approved} */}
                        {final2.total_grant_amount != null
                          ? changeNumberFormat(Number(final2.total_grant_amount), 2, 1)
                          : 0}{' '}
                      </span>

                    </span>
                    <br />
                    <span className="fund-amount-label">
                      Total Grant Approved
                    </span>
                  </div>
                  <div className="col-md-3 left-align">
                  <span className="fund-amount-cur">
            &#8377;
            <label className="fund-amount-label-value" style={{height:0}}>
              {/* {console.log(final2.total_management_amount,"336")} */}
              {' '}
              {final2.total_management_amount !== null && final2.total_management_amount !=="0"
                ? changeNumberFormat(Number(final2.total_management_amount), 2, 1)
                : 0}
            </label>
            {/* Cr */}
          </span>
          <br />
          <span className="fund-amount-label">Total Management <br/>Fees</span>
          <br />
                  </div>
                  <div className="col-md-3 left-align">
                    <span className="fund-amount-cur">
                      <span className="fund-amount-label-value">
                        {/* { //console.log(trancheData,"tranchData")} */}
                        {/* {trancheData.length}{' '} */}
                        {final2.total_no_of_tranches==null?0:final2.total_no_of_tranches}
                      </span>
                    </span>
                    <br />
                    <span className="fund-amount-label">
                      Total No. of Tranches
                    </span>
                  </div>

                  <div className="col-md-4 right">
                    <br />
                    {/* <a
                      className="incubator-details-link"
                      onClick={() => setIsAddTrancheRowVisible(true)}
                    >
                      +Add More Tranches{' '}
                    </a> */}
                  </div>
                </div>

                <div className="row">
                  <div className="table-scroll ">
                    <table id="example">
                      <thead>
                        <tr>
                          <th className="text-left custom-td-left table-heading">
                            Tranche Request
                          </th>
                          <th className="text-left custom-td-left table-heading">
                            Funds Approved
                          </th>
                          <th className="text-left table-heading">
                            Funds Disbursed
                          </th>
                          <th className="text-left table-heading"></th>
                        </tr>
                      </thead>
                      <tbody>
                        {isAddTrancheRowVisible == true ? (
                          <tr>
                            <td className="text-left ">
                              <span className="fund-amount-label">
                                {' '}
                                Tranche {final2.total_no_of_tranches + 1}
                              </span>
                            </td>
                            <td className="text-left custom-td-left">
                              <input
                                type="input"
                                placeholder="Enter"
                                name="amount_approved"
                                className="form-control input-height"
                                onChange={handleChange2}
                                value={addMoreTrancheData2.amount_approved}
                              />
                            </td>
                            <td className="text-left custom-td-left"></td>
                            <td>
                              <a
                                className="incubator-details-link"
                                // href="#"
                                onClick={() => addMoreTranche2()}
                              >
                                Save
                              </a>
                              |
                              <a
                                className="incubator-details-link"
                                href=""
                                onClick={() => cancel()}
                                data-dismiss="modal"
                              >
                                Cancel
                              </a>
                            </td>
                            {/* <td>
                              <a
                                className="incubator-details-link"
                                // href="#"
                                onClick={() => addMoreTranche2Edit()}
                              >
                                Edit
                              </a>
                              |
                              <a
                                className="incubator-details-link"
                                href=""
                                onClick={() => cancel()}
                                data-dismiss="modal"
                              >
                                Cancel
                              </a>
                            </td> */}
                          </tr>
                        ) : (
                          ''
                        )}
                        {/* {console.log(employeeData,"trancheDatalengthhhhhh")} */}
                        {employeeData != undefined && employeeData.length > 0 && final2.tranch_id !== null 
                          ? employeeData.map((item: any,i:any) => (
                            // (typeof item == Object ?
                            // typeof item == 'object' ?
                            <tr key={i}>
                              <td className="text-left ">
                                <span className="incubator-label-value">
                                  {item.tranche_number}
                                  {/* {console.log(item,"typeeeee")} */}
                                </span>
                                <br />
                                <span className="incubator-label">
                                  {' '}
                                  {item.tranche_requested_date != null ? formatDate(item.tranche_requested_date) : "-"}
                                </span>
                              </td>
                              <td className="text-left ">
                                <span className="incubator-label-value">
                                  {' '}
                                  
                                  <input
                                type="input"
                                placeholder="Enter"
                                name="approved_amount"
                                className="form-control input-height"
                                onChange={(e)=>handleChangeEdit2(e,item.tranch_id)}                                
                                // value={item.approved_amount}
                                value={item.editchecked == "Yes"?changeNumberFormat(Number(item.approved_amount), 2, 1):item.approved_amount}                                   
                                disabled={item.editchecked == "Yes"}
                                

                              />
                              {/* {changeNumberFormat(Number(item.approved_amount), 2, 1)} */}
                                </span>
                                <br />
                                {item.approved_amount != null ? (
                                  <span className="incubator-label">
                                    {' '}
                                    {item.approved_amount_date != null ? formatDate(item.approved_amount_date) : "-"}
                                  </span>
                                ) : (
                                  ''
                                )}
                              </td>
                              <td className="text-left ">
                                <span className="incubator-label-value">
                                  {' '}                                  
                                  <input
                                type="input"
                                placeholder="Enter"
                                name="fund_released"
                                className="form-control input-height"
                                onChange={(e)=>handleChangeEdit2(e,item.tranch_id)}
                                // value={changeNumberFormat(Number(item.fund_released), 2, 1)}
                                // value={item.fund_released}
                                value={item.editchecked == "Yes"?changeNumberFormat(Number(item.fund_released), 2, 1):item.fund_released}
                                disabled={item.editchecked == "Yes"}

                              />
                              {/* {changeNumberFormat(Number(item.fund_released), 2, 1)} */}
                                </span>
                                <br />
                                {item.fund_released != null ? (
                                  <span className="incubator-label">
                                    {' '}
                                    {item.date_of_release != null ? formatDate(item.date_of_release) : "-"}
                                  </span>
                                ) : (
                                  ''
                                )}
                              </td>
                              <td className="text-left custom-td-left">
                              {/* <td> */}
                              {/* {console.log("Checking Item",item)} */}
                            {item.editchecked == "Yes" ?  <a
                                className="incubator-details-link"
                                // href="#"
                                onClick={() => addMoreTranche2Edit(item.tranch_id)}
                              >
                                Edit
                              </a>:null}
                              {/* {console.log(item.editchecked,"editttttttttt")} */}
                            {item.editchecked == "No" ? <a
                                className="incubator-details-link"
                                // href="#"
                                onClick={() => addMoreTranche2Save(item,i,item.fund_released)}
                              >
                                Save
                              </a>:null}
                              |
                              <a
                                className="incubator-details-link"
                                href=""
                                onClick={() => cancel()}
                                data-dismiss="modal"
                              >
                                Cancel
                              </a>
                            {/* </td> */}
                                {/* <a
                                      className="incubator-details-link"
                                      href=""
                                      onClick={() =>
                                        handleRowChange(item.application_id)
                                      }
                                      data-dismiss="modal"
                                    >
                                      View
                                    </a> */}
                              </td>
                            </tr>
                            // :null
                            // :null
                            // )
                          ))
                          : ''}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div className="row pt-3 mb-3">
                <div className="col-md-12 centerText">
                  <button
                    className="tertiary  btn-yellow-primary"
                    // data-dismiss="modal" o
                    onClick={cancel}
                  >
                    OK
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* 2nd //View Bank Details */}

      <div
        className="modal fade"
        id="viewBankDetails2"
        role="dialog"
        aria-labelledby="exampleModalCenterTitle"
        aria-hidden="true"
      >
        <div
          className="modal-dialog modal-dialog-centered modal-lg"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header modal-header-border-none ml-18px">
              <h5 className="modal-title pl-2" id="exampleModalLongTitle">
                View Bank Details<span></span>
              </h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body text-left">
              <div className="container">
                <div className="row">
                  <div className="col-md-12">
                    <span className="incubator-label-value">Account Holder</span>
                  </div>
                </div>

                <div className="row mt-1-5">
                  <div className="col-md-6 left">
                    <span className="incubator-label">Account Name </span>
                  </div>
                  <div className="col-md-6 left">
                    <span className="incubator-label">Proof of PFMS Registration</span>
                  </div>
                </div>
{/* { //console.log(accountDetailsData2.bank_account_holder_name,"accountDetailsData2")} */}
                <div className="row ">
                  <div className="col-md-6 left">
                    <span className="incubator-label-value">
                      {accountDetailsData2.bank_account_holder_name == '' ||
                        accountDetailsData2.bank_account_holder_name == null
                        ? '-'
                        : accountDetailsData2.bank_account_holder_name}
                    </span>
                  </div>
                  <div className="col-md-6 left">
                    {/* {console.log(accountDetailsData2.pan_card_location,"Sri@@@@@@@2")} */}
                    
                    {accountDetailsData2.pan_card_location != undefined && accountDetailsData2.pan_card_location != null ? 
                    
                      <div className="row">
                        <div className="col-md-3">
                                                  {getFileDetails(
                            accountDetailsData2.pan_card_location,
                            'ext'
                          ) == 'pdf' ? (
                            <img src={pdf} alt="SISFS Logo" />
                          ) : getFileDetails(
                            accountDetailsData2.pan_card_location,
                            'ext'
                          ) == 'doc' ? (
                            <img src={doc} alt="SISFS Logo" />
                          ) : getFileDetails(
                            accountDetailsData2.pan_card_location,
                            'ext'
                          ) == 'xls' ? (
                            <img src={xls} alt="SISFS Logo" />
                          ) 
                          : (
                            <img src={Allround} alt="SISFS Logo" />
                          )
                          }
                        </div>
                        <div className="col-md-9" style={{wordBreak: 'break-all'}}>
                          <span className="document-label-value">
                            {getFileDetails(
                              accountDetailsData2.pan_card_location,
                              'name'
                            )}
                          </span>
                          <br />
                          <br />
                          {/* { //console.log(`${NODE_URL}`+ '/' + accountDetailsData2.pan_card_location)} */}
                          <a
                            // href={getFileDetails(accountDetailsData2.pan_card_location_name, "file")}
                            // href={`${NODE_URL}`+ accountDetailsData2.pan_card_location}
                            href={(accountDetailsData2.application_index == 'F1'?(`${File_base_url}` + accountDetailsData2.pan_card_location):(`${NODE_URL}`+  '/' + accountDetailsData2.pan_card_location))}
                            target="_blank"
                            //download="pan_card_location"
                            className="incubator-details-link"
                          >
                            View
                          </a>
                          {/* / */}
                          {/* <a
                            href="#"
                            //download="pan_card_location"
                            className="incubator-details-link"                           
                            onClick={() =>
                              {accountDetailsData2.application_index == "F1"? downloadDocument(
                                 accountDetailsData2.pan_card_location,
                                 accountDetailsData2.pan_card_location
                               )
                             : downloadDocument1(accountDetailsData2.pan_card_location,accountDetailsData2.pan_card_location)}}
                          >
                            Download
                          </a> */}
                        </div>
                      </div>
                      : ""}
                  </div>
                </div>

                 <div className="row mt-1-5">
                  <div className="col-md-6 left">
                    <span className="incubator-label">
                      Proof of TRA Account & ECS Mandate Form
                    </span>
                    <br />
                   {accountDetailsData2.cancelled_cheque_location != undefined && accountDetailsData2.cancelled_cheque_location != null ?
                      <div className="row">
                        <div className="col-md-3">
                          {getFileDetails(
                            accountDetailsData2.cancelled_cheque_location,
                            'ext'
                          ) == 'pdf' ? (
                            <img src={pdf} alt="SISFS Logo" />
                          ) : getFileDetails(
                            accountDetailsData2.cancelled_cheque_location,
                            'ext'
                          ) == 'doc' ? (
                            <img src={doc} alt="SISFS Logo" />
                          ) : getFileDetails(
                            accountDetailsData2.cancelled_cheque_location,
                            'ext'
                          ) == 'xls' ? (
                            <img src={xls} alt="SISFS Logo" />
                          ) : (
                            <img src={Allround} alt="SISFS Logo" />
                          )}
                        </div>
                        <div className="col-md-9" style={{wordBreak: 'break-all'}}>
                          <span className="document-label-value">
                            {getFileDetails(
                              accountDetailsData2.cancelled_cheque_location,
                              'name'
                            )}
                          </span>
                          <br />
                          <br />
                          {/* {console.log(`${NODE_URL}`+ '/' + accountDetailsData2.cancelled_cheque_location)} */}

                          <a                            
                            href={(accountDetailsData2.application_index == 'F1'?(`${File_base_url}` + accountDetailsData2.cancelled_cheque_location):(`${NODE_URL}`+  '/' + accountDetailsData2.cancelled_cheque_location))}
                            target="_blank"
                            //download="proof_of_disbursement"
                            className="incubator-details-link"
                          >
                            View
                          </a>
                          {/* /
                          <a
                            href="#"
                            //download="proof_of_disbursement"
                            className="incubator-details-link"                          

                            onClick={() =>
                              {accountDetailsData2.application_index == "F1"? downloadDocument(
                                 accountDetailsData2.cancelled_cheque_location,
                                 accountDetailsData2.cancelled_cheque_location
                               )
                             : downloadDocument1(accountDetailsData2.cancelled_cheque_location,accountDetailsData2.cancelled_cheque_location )}}
                          >
                            Download
                          </a> */}
                        </div>
                      </div>
                      : ""} 


                  </div>
                  <div className="col-md-4">
                  <span className="incubator-label">
                    Proof of DARPAN
                    </span>
                    <br />
                  {accountDetailsData2.darpan_location != undefined && accountDetailsData2.darpan_location != null ?
                      <div className="row">
                        <div className="col-md-3">
                          {getFileDetails(
                            accountDetailsData2.darpan_location,
                            'ext'
                          ) == 'pdf' ? (
                            <img src={pdf} alt="SISFS Logo" />
                          ) : getFileDetails(
                            accountDetailsData2.darpan_location,
                            'ext'
                          ) == 'doc' ? (
                            <img src={doc} alt="SISFS Logo" />
                          ) : getFileDetails(
                            accountDetailsData2.darpan_location,
                            'ext'
                          ) == 'xls' ? (
                            <img src={xls} alt="SISFS Logo" />
                          ) : (
                            <img src={Allround} alt="SISFS Logo" />
                          )}
                        </div>
                        <div className="col-md-9" style={{wordBreak: 'break-all'}}>
                          <span className="document-label-value">
                            {getFileDetails(
                              accountDetailsData2.darpan_location,
                              'name'
                            )}
                          </span>
                          <br />
                          <br />
                          <a                            
                            href={(accountDetailsData2.application_index == 'F1'?(`${File_base_url}` + accountDetailsData2.darpan_location):(`${NODE_URL}`+  '/' + accountDetailsData2.darpan_location))}
                            target="_blank"
                            //download="proof_of_disbursement"
                            className="incubator-details-link"
                          >
                            View
                          </a>
                          {/* /
                          <a
                            href="#"
                            //download="proof_of_disbursement"
                            className="incubator-details-link"
                            
                            onClick={() =>
                              {accountDetailsData2.application_index == "F1"? downloadDocument(
                                 accountDetailsData2.darpan_location,
                                 accountDetailsData2.darpan_location
                               )
                             : downloadDocument1(accountDetailsData2.darpan_location,accountDetailsData2.darpan_location )}}
                            
                          >
                            Download
                          </a> */}
                        </div>
                      </div>
                      : ""} 
                  </div>
                </div> 
                <div className="application-incubator-hr">

                  <hr />
                </div>
                <div className="row">
                  <div className="col-md-12">
                    <span className="incubator-label-value">Account Details</span>
                  </div>
                </div>

                <div className="row mt-1-5">
                  <div className="col-md-6 left">
                    <span className="incubator-label">Bank Name</span>
                  </div>
                  <div className="col-md-4">
                    <span className="incubator-label">Account Number</span>
                  </div>
                </div>

                <div className="row ">
                  <div className="col-md-6 left">
                    <span className="incubator-label-value">
                      {accountDetailsData2.bank_name == '' ||
                        accountDetailsData2.bank_name == null
                        ? '-'
                        : accountDetailsData2.bank_name}
                    </span>
                  </div>
                  <div className="col-md-6">
                    <span className="incubator-label-value">
                      {accountDetailsData2.account_number == '0' ||
                        accountDetailsData2.account_number == null
                        ? '-'
                        : accountDetailsData2.account_number}
                    </span>
                  </div>
                </div>

                <div className="row mt-1-5">
                  <div className="col-md-6 left">
                    <span className="incubator-label">Account Type</span>
                  </div>
                  <div className="col-md-6 left">
                    <span className="incubator-label">
                      Branch Name/Branch Code
                    </span>
                  </div>
                </div>

                <div className="row ">
                  <div className="col-md-6 left">
                    <span className="incubator-label-value">
                      {accountDetailsData2.account_type == 0 ||
                        accountDetailsData2.account_type == null
                        ? '-'
                        : accountDetailsData2.account_type}
                    </span>
                  </div>
                  <div className="col-md-6 left">
                    <span className="incubator-label-value">
                      {accountDetailsData2.branch_name == '' ||
                        accountDetailsData2.branch_name == null
                        ? '-'
                        : accountDetailsData2.branch_name}
                    </span>
                  </div>
                </div>

                <div className="row mt-1-5">
                  <div className="col-md-6 left">
                    <span className="incubator-label">IFSC Code</span>
                  </div>
                  <div className="col-md-6 left">
                    <span className="incubator-label">MICR Code</span>
                  </div>
                </div>

                <div className="row ">
                  <div className="col-md-6 left">
                    <span className="incubator-label-value">
                      {accountDetailsData2.bank_ifsc_code == '' ||
                        accountDetailsData2.bank_ifsc_code == null
                        ? '-'
                        : accountDetailsData2.bank_ifsc_code}
                    </span>
                  </div>
                  <div className="col-md-6 left">
                    <span className="incubator-label-value">
                      {accountDetailsData2.bank_micr_code == '' ||
                        accountDetailsData2.bank_micr_code == null
                        ? '-'
                        : accountDetailsData2.bank_micr_code}
                    </span>
                  </div>
                </div>

                <div className="row mt-1-5">
                  <div className="col-md-6 left">
                    <span className="incubator-label">Bank Address</span>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-6 left">
                    <span className="incubator-label-value">
                      {accountDetailsData2.branch_address == '' ||
                        accountDetailsData2.branch_address == null
                        ? '-'
                        : accountDetailsData2.branch_address}
                    </span>
                  </div>
                </div>
              </div>
              <div className="row pt-3 mb-3">
                <div className="col-md-12 centerText">
                  <button
                    className="tertiary  btn-yellow-primary"
                    data-dismiss="modal"
                  >
                    OK
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

        {/* 2nd Total Grant Approved Edit pop up */}
        <div
        className="modal fade"
        id="editTotalGrantApproved2"
        role="dialog"
        aria-labelledby="exampleModalCenterTitle"
        aria-hidden="true"
      >
        <div
          className="modal-dialog modal-dialog-centered modal-md"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header modal-header-border-none">
              <h5 className="modal-title " id="exampleModalLongTitle">
                Update Total Grant Approved <span className="eac-name-pop-up"></span>
              </h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="row">
                <div className="col-md-12 text-left">
                  <span className="col-form-head">Total Grant Approved</span>
                </div>
              </div>
              <div className="row mt-1-5">
                <div className="col-md-12 text-left">
                  <input
                    type="number"
                    className="form-control"
                    name="total_approved_amt"
                    value={quickEditPopupData.total_approved_amt}
                    placeholder="Enter total grant approved"
                    onChange={handleChangeTotalGrantApproved2}
                  ></input>

                </div>
              </div>

              <div className="row">
                <div className="col-md-12 text-right">
                  <div className="btn-group mt-1-5 ">
                    <button
                      className="tertiary   btn-transparent-primary"
                      data-dismiss="modal"
                    >
                      Cancel
                    </button>

                    <button
                      type="button"
                      className="btn btn-sisfs btn-yellow-primary ml-2"
                      onClick={() => updateTotalGrantApproved2()}
                      data-dismiss="modal"
                    >
                      Update{' '}
                    </button>
                  </div>
                </div>
              </div>

              <div className="row pt-3 mb-3">
                <div className="col-md-12 centerText"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
  {/* 1st Total Grant Approved Edit pop up */}
  <div
        className="modal fade"
        id="editTotalGrantApproved1"
        role="dialog"
        aria-labelledby="exampleModalCenterTitle"
        aria-hidden="true"
      >
        <div
          className="modal-dialog modal-dialog-centered modal-md"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header modal-header-border-none">
              <h5 className="modal-title " id="exampleModalLongTitle">
                Update Total Grant Approved <span className="eac-name-pop-up"></span>
              </h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="row">
                <div className="col-md-12 text-left">
                  <span className="col-form-head">Total Grant Approved</span>
                </div>
              </div>
              <div className="row mt-1-5">
                <div className="col-md-12 text-left">
                  <input
                    type="number"
                    className="form-control"
                    name="total_approved_amt"
                    value={quickEditPopupData.total_approved_amt}
                    placeholder="Enter total grant approved"
                    onChange={handleChangeTotalGrantApproved1}
                  ></input>

                </div>
              </div>

              <div className="row">
                <div className="col-md-12 text-right">
                  <div className="btn-group mt-1-5 ">
                    <button
                      className="tertiary   btn-transparent-primary"
                      data-dismiss="modal"
                    >
                      Cancel
                    </button>

                    <button
                      type="button"
                      className="btn btn-sisfs btn-yellow-primary ml-2"
                      onClick={() => updateTotalGrantApproved1()}
                      data-dismiss="modal"
                    >
                      Update{' '}
                    </button>
                  </div>
                </div>
              </div>

              <div className="row pt-3 mb-3">
                <div className="col-md-12 centerText"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* 1st add more tranche model */}
      <div
        className="modal fade"
        id="addMoreTranchePopUp1"
        role="dialog"
        aria-labelledby="exampleModalCenterTitle"
        aria-hidden="true"
        data-backdrop="static"
        data-keyboard="false"
      >
        <div
          className="modal-dialog modal-dialog-centered modal-lg"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header modal-header-border-none ml-18px">
              <h5 className="modal-title pl-2" id="exampleModalLongTitle">
                Add More Tranche<span></span>
              </h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true" onClick={cancel}>&times;</span>
              </button>
            </div>
            <div className="modal-body mt-15-px">
              <div className="container">
                <div className="row">
                  <div className="col-md-3 left-align">
                    <span className="fund-amount-cur">
                      &#8377;
                      <span className="fund-amount-label-value">
                        {' '}
                        {/* {total_grand_approved} */}
                        {final1.total_grant_amount != null
                          ? changeNumberFormat(Number(final1.total_grant_amount), 2, 1)
                          : 0}{' '}
                      </span>

                    </span>
                    <br />
                    <span className="fund-amount-label">
                      Total Grant Approved
                    </span>
                  </div>
                  <div className="col-md-3 left-align">
                  <span className="fund-amount-cur">
            &#8377;
            <label className="fund-amount-label-value" style={{height:0}}>
              {/* {console.log(final1.total_management_amount,"336")} */}
              {' '}
              {final1.total_management_amount !== null && final1.total_management_amount !=="0"
                ? changeNumberFormat(Number(final1.total_management_amount), 2, 1)
                : 0}
            </label>
            {/* Cr */}
          </span>
          <br />
          <span className="fund-amount-label">Total Management <br/>Fees</span>
          <br />
                  </div>
                  <div className="col-md-3 left-align">
                    <span className="fund-amount-cur">
                      <span className="fund-amount-label-value">
                        {/* { //console.log(trancheData,"tranchData")} */}
                        {/* {trancheData.length}{' '} */}
                        {final1.total_no_of_tranches==null?0:final1.total_no_of_tranches}
                      </span>
                    </span>
                    <br />
                    <span className="fund-amount-label">
                      Total No. of Tranches
                    </span>
                  </div>

                  <div className="col-md-4 right">
                    <br />
                    {/* <a
                      className="incubator-details-link"
                      onClick={() => setIsAddTrancheRowVisible(true)}
                    >
                      +Add More Tranches{' '}
                    </a> */}
                  </div>
                </div>

                <div className="row">
                  <div className="table-scroll ">
                    <table id="example">
                      <thead>
                        <tr>
                          <th className="text-left custom-td-left table-heading">
                            Tranche Request
                          </th>
                          <th className="text-left custom-td-left table-heading">
                           Funds Approved
                          </th>
                          <th className="text-left table-heading">
                           Funds Disbursed
                          </th>
                          <th className="text-left table-heading"></th>
                        </tr>
                      </thead>
                      <tbody>
                        {isAddTrancheRowVisible1 == true ? (
                          <tr>
                            <td className="text-left ">
                              <span className="fund-amount-label">
                                {' '}
                                Tranche {final1.total_no_of_tranches + 1}
                              </span>
                            </td>
                            <td className="text-left custom-td-left">
                              <input
                                type="input"
                                placeholder="Enter"
                                name="amount_approved"
                                className="form-control input-height"
                                onChange={handleChange1}
                                value={addMoreTrancheData1.amount_approved}
                              />
                            </td>
                            <td className="text-left custom-td-left"></td>
                            <td>
                              <a
                                className="incubator-details-link"
                                // href="#"
                                onClick={() => addMoreTranche1()}
                              >
                                Save
                              </a>
                              |
                              <a
                                className="incubator-details-link"
                                href=""
                                onClick={() => cancel()}
                                data-dismiss="modal"
                              >
                                Cancel
                              </a>
                            </td>
                          </tr>
                        ) : (
                          ''
                        )}
         {/* {console.log(employeeData1,"releeeeeeeeeeeeee")} */}
                        {employeeData1 != undefined && employeeData1.length > 0 && final1.tranch_id !== null
                          ? 
                          employeeData1.map((item: any,i:any) => (
                              <tr key={i}>
                                <td className="text-left ">
                                  <span className="incubator-label-value">
                                    {item.tranche_number}
                                  </span>
                                  <br />
                                  <span className="incubator-label">
                                    {' '}
                                    {item.tranche_requested_date != null ? formatDate(item.tranche_requested_date) : "-"}
                                  </span>
                                </td>
                                <td className="text-left ">
                                  <span className="incubator-label-value">
                                    {' '}
                                    
                                    <input
                                  type="input"
                                  placeholder="Enter"
                                  name="approved_amount"
                                  className="form-control input-height"
                                  onChange={(e)=>handleChangeEdit1(e,item.tranch_id)}                                
                                  // value={changeNumberFormat(Number(item.approved_amount), 2, 1)}
                                  value={item.editchecked == "Yes" ? changeNumberFormat(Number(item.approved_amount), 2, 1):item.approved_amount}
                                  disabled={item.editchecked == "Yes"}
                                  
  
                                />
                                {/* {changeNumberFormat(Number(item.approved_amount), 2, 1)} */}
                                  </span>
                                  <br />
                                  {item.approved_amount != null ? (
                                    <span className="incubator-label">
                                      {' '}
                                      {item.approved_amount_date != null ? formatDate(item.approved_amount_date) : "-"}
                                    </span>
                                  ) : (
                                    ''
                                  )}
                                </td>
                                <td className="text-left ">
                                  <span className="incubator-label-value">
                                    {' '}                                  
                                    <input
                                  type="input"
                                  placeholder="Enter"
                                  name="fund_released"
                                  className="form-control input-height"
                                  onChange={(e)=>handleChangeEdit1(e,item.tranch_id)}
                                  // value={changeNumberFormat(Number(item.fund_released), 2, 1)}
                                  // value={item.fund_released}
                                  value={item.editchecked == "Yes" ? changeNumberFormat(Number(item.fund_released), 2, 1):item.fund_released}
                                  disabled={item.editchecked == "Yes"}
  
                                />
                                {/* {changeNumberFormat(Number(item.fund_released), 2, 1)} */}
                                  </span>
                                  <br />
                                  {item.fund_released != null ? (
                                    <span className="incubator-label">
                                      {' '}
                                      {item.date_of_release != null ? formatDate(item.date_of_release) : "-"}
                                    </span>
                                  ) : (
                                    ''
                                  )}
                                </td>
                                <td className="text-left custom-td-left">
                                {/* <td> */}
                                {/* {console.log("Checking Item",item)} */}
                              {item.editchecked == "Yes" ?  <a
                                  className="incubator-details-link"
                                  // href="#"
                                  onClick={() => addMoreTranche1Edit(item.tranch_id)}
                                >
                                  Edit
                                </a>:null}
                                {/* {console.log(item.editchecked,"editttttttttt")} */}
                              {item.editchecked == "No" ? <a
                                  className="incubator-details-link"
                                  // href="#"
                                  onClick={() => addMoreTranche1Save(item,i)}
                                >
                                  Save
                                </a>:null}
                                |
                                <a
                                  className="incubator-details-link"
                                  href=""
                                  onClick={() => cancel()}
                                  data-dismiss="modal"
                                >
                                  Cancel
                                </a>
                              {/* </td> */}
                                  {/* <a
                                        className="incubator-details-link"
                                        href=""
                                        onClick={() =>
                                          handleRowChange(item.application_id)
                                        }
                                        data-dismiss="modal"
                                      >
                                        View
                                      </a> */}
                                </td>
                              </tr>
                          ))
                          : ''}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div className="row pt-3 mb-3">
                <div className="col-md-12 centerText">
                  <button
                    className="tertiary  btn-yellow-primary"
                    // data-dismiss="modal"
                    onClick={cancel}                    
                  >
                    OK
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

{/* 1st bank details model */}
<div
        className="modal fade"
        id="viewBankDetails1"
        role="dialog"
        aria-labelledby="exampleModalCenterTitle"
        aria-hidden="true"
      >
        <div
          className="modal-dialog modal-dialog-centered modal-lg"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header modal-header-border-none ml-18px">
              <h5 className="modal-title pl-2" id="exampleModalLongTitle">
                View Bank Details<span></span>
              </h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body text-left">
              <div className="container">
                <div className="row">
                  <div className="col-md-12">
                    <span className="incubator-label-value">Account Holder</span>
                  </div>
                </div>

                <div className="row mt-1-5">
                  <div className="col-md-6 left">
                    <span className="incubator-label">Account Name </span>
                  </div>
                  <div className="col-md-6 left">
                    <span className="incubator-label">Proof of PFMS Registration</span>
                  </div>
                </div>
{/* {console.log(accountDetailsData1.length,"accountDetailsData1")}  */}

                <div className="row ">
                  <div className="col-md-6 left">
                    <span className="incubator-label-value">
                      {accountDetailsData1.bank_account_holder_name == '' ||
                        accountDetailsData1.bank_account_holder_name == null
                        ? '-'
                        : accountDetailsData1.bank_account_holder_name}
                    </span>
                  </div>
                  <div className="col-md-6 left">
                    {/* {console.log(accountDetailsData1.pan_card_location,"Sri@@@@@@@2")} */}
                    
                    {accountDetailsData1.pan_card_location != undefined && accountDetailsData1.pan_card_location != null ? 
                    
                      <div className="row">
                        <div className="col-md-3">
                                                  {getFileDetails(
                            accountDetailsData1.pan_card_location,
                            'ext'
                          ) == 'pdf' ? (
                            <img src={pdf} alt="SISFS Logo" />
                          ) : getFileDetails(
                            accountDetailsData1.pan_card_location,
                            'ext'
                          ) == 'doc' ? (
                            <img src={doc} alt="SISFS Logo" />
                          ) : getFileDetails(
                            accountDetailsData1.pan_card_location,
                            'ext'
                          ) == 'xls' ? (
                            <img src={xls} alt="SISFS Logo" />
                          ) 
                          : (
                            <img src={Allround} alt="SISFS Logo" />
                          )
                          }
                        </div>
                        <div className="col-md-9" style={{wordBreak: 'break-all'}}>
                          <span className="document-label-value">
                            {getFileDetails(
                              accountDetailsData1.pan_card_location,
                              'name'
                            )}
                          </span>
                          <br />
                          <br />
                          <a                          
                            href={(accountDetailsData1.application_index == 'F1'?(`${File_base_url}` + accountDetailsData1.pan_card_location):(`${NODE_URL}`+  '/' + accountDetailsData1.pan_card_location))}
                            target="_blank"
                            //download="pan_card_location"
                            className="incubator-details-link"
                          >
                            View
                          </a>
                          {/* /
                          <a
                            href="#"
                            //download="pan_card_location"
                            className="incubator-details-link"                           
                            onClick={() =>
                              {accountDetailsData1.application_index == "F1"? downloadDocument(
                                 accountDetailsData1.pan_card_location,
                                 accountDetailsData1.pan_card_location
                               )
                             : downloadDocument1(accountDetailsData1.pan_card_location,accountDetailsData1.pan_card_location )}}
                          >
                            Download
                          </a> */}
                        </div>
                      </div>
                      : ""}
                  </div>
                </div>
                {/* :null} */}

                 <div className="row mt-1-5">
                  <div className="col-md-6 left">
                    <span className="incubator-label">
                      Proof of TRA Account & ECS Mandate Form
                    </span>
                    <br />
                   {accountDetailsData1.cancelled_cheque_location != undefined && accountDetailsData1.cancelled_cheque_location != null ?
                      <div className="row">
                        <div className="col-md-3">
                          {getFileDetails(
                            accountDetailsData1.cancelled_cheque_location,
                            'ext'
                          ) == 'pdf' ? (
                            <img src={pdf} alt="SISFS Logo" />
                          ) : getFileDetails(
                            accountDetailsData1.cancelled_cheque_location,
                            'ext'
                          ) == 'doc' ? (
                            <img src={doc} alt="SISFS Logo" />
                          ) : getFileDetails(
                            accountDetailsData1.cancelled_cheque_location,
                            'ext'
                          ) == 'xls' ? (
                            <img src={xls} alt="SISFS Logo" />
                          ) : (
                            <img src={Allround} alt="SISFS Logo" />
                          )}
                        </div>
                        <div className="col-md-9" style={{wordBreak: 'break-all'}}>
                          <span className="document-label-value">
                            {getFileDetails(
                              accountDetailsData1.cancelled_cheque_location,
                              'name'
                            )}
                          </span>
                          <br />
                          <br />
                          {/* {console.log(`${NODE_URL}`+ '/' + accountDetailsData1.cancelled_cheque_location)} */}

                          <a                           
                            href={(accountDetailsData1.application_index == 'F1'?(`${File_base_url}` + accountDetailsData1.cancelled_cheque_location):(`${NODE_URL}`+  '/' + accountDetailsData1.cancelled_cheque_location))}
                            target="_blank"
                            //download="proof_of_disbursement"
                            className="incubator-details-link"
                          >
                            View
                          </a>
                          {/* /
                          <a
                            href="#"
                            //download="proof_of_disbursement"
                            className="incubator-details-link"                           

                            onClick={() =>
                              {accountDetailsData1.application_index == "F1"? downloadDocument(
                                 accountDetailsData1.cancelled_cheque_location,
                                 accountDetailsData1.cancelled_cheque_location
                               )
                             : downloadDocument1(accountDetailsData1.cancelled_cheque_location,accountDetailsData1.cancelled_cheque_location )}}
                          >
                            Download
                          </a> */}
                        </div>
                      </div>
                      : ""} 


                  </div>
                  <div className="col-md-4">
                  <span className="incubator-label">
                    Proof of DARPAN
                    </span>
                    <br />
                  {accountDetailsData1.darpan_location != undefined && accountDetailsData1.darpan_location != null ?
                      <div className="row">
                        <div className="col-md-3">
                          {getFileDetails(
                            accountDetailsData1.darpan_location,
                            'ext'
                          ) == 'pdf' ? (
                            <img src={pdf} alt="SISFS Logo" />
                          ) : getFileDetails(
                            accountDetailsData1.darpan_location,
                            'ext'
                          ) == 'doc' ? (
                            <img src={doc} alt="SISFS Logo" />
                          ) : getFileDetails(
                            accountDetailsData1.darpan_location,
                            'ext'
                          ) == 'xls' ? (
                            <img src={xls} alt="SISFS Logo" />
                          ) : (
                            <img src={Allround} alt="SISFS Logo" />
                          )}
                        </div>
                        <div className="col-md-9"  style={{wordBreak: 'break-all'}}>
                          <span className="document-label-value">
                            {getFileDetails(
                              accountDetailsData1.darpan_location,
                              'name'
                            )}
                          </span>
                          <br />
                          <br />
                          <a                            
                            href={(accountDetailsData1.application_index == 'F1'?(`${File_base_url}` + accountDetailsData1.darpan_location):(`${NODE_URL}`+  '/' + accountDetailsData1.darpan_location))}
                            target="_blank"
                            //download="proof_of_disbursement"
                            className="incubator-details-link"
                          >
                            View
                          </a>
                          {/* /
                          <a
                            href="#"
                            //download="proof_of_disbursement"
                            className="incubator-details-link"
                            onClick={() =>
                             {accountDetailsData1.application_index == "F1"? downloadDocument(
                                accountDetailsData1.darpan_location,
                                accountDetailsData1.darpan_location
                              )
                            : downloadDocument1(accountDetailsData1.darpan_location,accountDetailsData1.darpan_location )}}
                          >
                            Download
                          </a> */}
                        </div>
                      </div>
                      : ""} 
                  </div>
                </div> 
                <div className="application-incubator-hr">

                  <hr />
                </div>
                <div className="row">
                  <div className="col-md-12">
                    <span className="incubator-label-value">Account Details</span>
                  </div>
                </div>

                <div className="row mt-1-5">
                  <div className="col-md-6 left">
                    <span className="incubator-label">Bank Name</span>
                  </div>
                  <div className="col-md-4">
                    <span className="incubator-label">Account Number</span>
                  </div>
                </div>

                <div className="row ">
                  <div className="col-md-6 left">
                    <span className="incubator-label-value">
                      {accountDetailsData1.bank_name == '' ||
                        accountDetailsData1.bank_name == null
                        ? '-'
                        : accountDetailsData1.bank_name}
                    </span>
                  </div>
                  <div className="col-md-6">
                    <span className="incubator-label-value">
                      {accountDetailsData1.account_number == '0' ||
                        accountDetailsData1.account_number == null
                        ? '-'
                        : accountDetailsData1.account_number}
                    </span>
                  </div>
                </div>

                <div className="row mt-1-5">
                  <div className="col-md-6 left">
                    <span className="incubator-label">Account Type</span>
                  </div>
                  <div className="col-md-6 left">
                    <span className="incubator-label">
                      Branch Name/Branch Code
                    </span>
                  </div>
                </div>

                <div className="row ">
                  <div className="col-md-6 left">
                    <span className="incubator-label-value">
                      {accountDetailsData1.account_type == 0 ||
                        accountDetailsData1.account_type == null
                        ? '-'
                        : accountDetailsData1.account_type}
                    </span>
                  </div>
                  <div className="col-md-6 left">
                    <span className="incubator-label-value">
                      {accountDetailsData1.branch_name == '' ||
                        accountDetailsData1.branch_name == null
                        ? '-'
                        : accountDetailsData1.branch_name}
                    </span>
                  </div>
                </div>

                <div className="row mt-1-5">
                  <div className="col-md-6 left">
                    <span className="incubator-label">IFSC Code</span>
                  </div>
                  <div className="col-md-6 left">
                    <span className="incubator-label">MICR Code</span>
                  </div>
                </div>

                <div className="row ">
                  <div className="col-md-6 left">
                    <span className="incubator-label-value">
                      {accountDetailsData1.bank_ifsc_code == '' ||
                        accountDetailsData1.bank_ifsc_code == null
                        ? '-'
                        : accountDetailsData1.bank_ifsc_code}
                    </span>
                  </div>
                  <div className="col-md-6 left">
                    <span className="incubator-label-value">
                      {accountDetailsData1.bank_micr_code == '' ||
                        accountDetailsData1.bank_micr_code == null
                        ? '-'
                        : accountDetailsData1.bank_micr_code}
                    </span>
                  </div>
                </div>

                <div className="row mt-1-5">
                  <div className="col-md-6 left">
                    <span className="incubator-label">Bank Address</span>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-6 left">
                    <span className="incubator-label-value">
                      {accountDetailsData1.branch_address == '' ||
                        accountDetailsData1.branch_address == null
                        ? '-'
                        : accountDetailsData1.branch_address}
                    </span>
                  </div>
                </div>
              </div>
              <div className="row pt-3 mb-3">
                <div className="col-md-12 centerText">
                  <button
                    className="tertiary  btn-yellow-primary"
                    data-dismiss="modal"
                  >
                    OK
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* sccess and failure models  */}
      {showEditSuccessModal && (
        <>
          <div className="modal-backdrop fade show"></div>

          <div
            className="modal align-middle modal-sisfs d-block"
            id="FormSubmissionSuccess"
          >
            <div className="modal-dialog modal-dialog-centered modal-md">
              <div className="modal-content">
                <div className="modal-body text-center">
                  <i className="fa fa-check-circle-o"></i>
                  <h3 className="modal-message">Thank You !</h3>
                  <div className="modal-text">
                    Tranche Details Updated Successfully !!
                  </div>
                  <div className="modal-action">
                    <button
                      className="btn btn-sisfs btn-yellow-primary"
                      onClick={dismissModal}
                    >
                      Ok !!
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
      {showEditFailureModal && (
        <>
          <div className="modal-backdrop fade show"></div>
          <div
            className="modal align-middle modal-sisfs d-block"
            id="FormSubmissionError"
          >
            <div className="modal-dialog modal-dialog-centered modal-md">
              <div className="modal-content">
                <div className="modal-body text-center">
                  {/* <i className="fa fa-times-circle-o"></i> */}
                  <h3 className="modal-message message-orange">
                    Oops! The Amount Should be Greater than 0
                  </h3>
                  <br />
                  <h3 className="modal-message message-orange">
                    Please Try Again !!!
                  </h3>
                  <div className="modal-action">
                    <button
                      className="btn btn-sisfs btn-yellow-primary"
                      onClick={dismissModal1}
                    >
                      OK !
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
       {showIncubatorFailureModal && (       
        <ConfirmationDialogNote
        headerText={failDialogData.header}
        bodyText={failDialogData.text}
        bodyNote={failDialogData.note}        
        onDialogClose={() => setShowIncubatorFailureModal(false)}
        iconClass="showImage"
      />
      )}
      
    </div>
  );
}
export default MergedFundDetailsComponent;
